import { StringFieldType } from "./StringFieldType";

export const inputTypeMappings: Partial<Record<StringFieldType, string>> = {
  Boolean: "checkbox",
  Int: "number",
  String: "text",
  Float: "number",
  AWSEmail: "email",
  AWSDate: "date",
  AWSDateTime: "text",
  AWSTime: "time",
  AWSURL: "url",
  AWSTimestamp: "datetime-local",
};
